





































































































































import mixins from 'vue-typed-mixins';
import { EscalationGroup } from '../EscalationGroup';
import { EscalationType } from '../EscalationType';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import BuildEntityListComponentMixin from '@/Shared/CommonEntityMixins/EntityListComponentMixin';
import { AxiosResponse } from 'axios';
import RadioToggle from '@/Shared/RadioToggle.vue';
import VatsAPI from '@/Shared/VatsAPI';

const component = mixins(LocationBasedMixin, BuildEntityListComponentMixin<EscalationGroup>()).extend({
    components: {
        RadioToggle
    },
    data() {
        return {
            i18nPrefix: 'admin.programVariables.escalationManagement.escalationGroup',
            EscalationType,
            escalationTypeDisplay: Object.keys(EscalationType)
                .filter(k => typeof EscalationType[k as any] === 'string'),
        };
    },
    computed: {
        entityUrls(): string {
            return `${this.location}/Citations/EscalationVariables/EscalationGroups`;
        }
    },
    filters: {
        formatPayment(value: string) {
            if (!value) {
                return '0.00';
            }
            return parseFloat(value).toFixed(2);
        }
    },
});

export default component;
